import '../node_modules/bootstrap/scss/bootstrap.scss' 
import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode'
import Viewer, { Worker } from '@phuocng/react-pdf-viewer';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import Velocity from 'velocity-animate';


// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";


import fullcolor from './img/productos/fullcolor.png'

import fullcolor_casa from './img/fullcolor/fullcolor_casa.jpg'
import clip_pavimento from './img/fullcolor/mascara_pavimento.png'
import clip_muro from './img/fullcolor/mascara_muro.png'

import AUSTIN_BUFF from './img/fullcolor/AUSTIN_BUFF.jpg'
import AUTUMN_BROWN from './img/fullcolor/AUTUMN_BROWN.jpg'
import BRICK_RED from './img/fullcolor/BRICK_RED.jpg'
import CHARCOAL from './img/fullcolor/CHARCOAL.jpg'
import CHEROKEE_RED from './img/fullcolor/CHEROKEE_RED.jpg'
import COCOA from './img/fullcolor/COCOA.jpg'
import CORDOVA from './img/fullcolor/CORDOVA.jpg'
import DARK_GRAY from './img/fullcolor/DARK_GRAY.jpg'
import DESERT_TAN from './img/fullcolor/DESERT_TAN.jpg'
import EURO_GRAY from './img/fullcolor/EURO_GRAY.jpg'
import FIESTA from './img/fullcolor/FIESTA.jpg'
import MAPLEWOOD from './img/fullcolor/MAPLEWOOD.jpg'
import NAVAJO from './img/fullcolor/NAVAJO.jpg'
import PECOS_BEIGE from './img/fullcolor/PECOS_BEIGE.jpg'
import PHOENIX_TAN from './img/fullcolor/PHOENIX_TAN.jpg'
import PUEBLO from './img/fullcolor/PUEBLO.jpg'
import REDWOOD from './img/fullcolor/REDWOOD.jpg'
import SALTILLO from './img/fullcolor/SALTILLO.jpg'
import SAN_JOSE_BUFF from './img/fullcolor/SAN_JOSE_BUFF.jpg'
import SAND_BUFF from './img/fullcolor/SAND_BUFF.jpg'
import SANDSTONE from './img/fullcolor/SANDSTONE.jpg'
import SEDONA from './img/fullcolor/SEDONA.jpg'
import SILVER_GRAY from './img/fullcolor/SILVER_GRAY.jpg'
import SOFT_GRAY from './img/fullcolor/SOFT_GRAY.jpg'
import SOMBRA from './img/fullcolor/SOMBRA.jpg'
import TAHOE_RED from './img/fullcolor/TAHOE_RED.jpg'
import TERRA_COTTA from './img/fullcolor/TERRA_COTTA.jpg'
import TIERRA from './img/fullcolor/TIERRA.jpg'
import TILE_RED from './img/fullcolor/TILE_RED.jpg'
import YUMA_GOLD from './img/fullcolor/YUMA_GOLD.jpg'

// import AUSTIN_BUFF from './img/fullcolor/AUSTIN_BUFF copy.jpg'
// import AUTUMN_BROWN from './img/fullcolor/AUTUMN_BROWN copy.jpg'
// import BRICK_RED from './img/fullcolor/BRICK_RED copy.jpg'
// import CHARCOAL from './img/fullcolor/CHARCOAL copy.jpg'
// import CHEROKEE_RED from './img/fullcolor/CHEROKEE_RED copy.jpg'
// import COCOA from './img/fullcolor/COCOA copy.jpg'
// import CORDOVA from './img/fullcolor/CORDOVA copy.jpg'
// import DARK_GRAY from './img/fullcolor/DARK_GRAY copy.jpg'
// import DESERT_TAN from './img/fullcolor/DESERT_TAN copy.jpg'
// import EURO_GRAY from './img/fullcolor/EURO_GRAY copy.jpg'
// import FIESTA from './img/fullcolor/FIESTA copy.jpg'
// import MAPLEWOOD from './img/fullcolor/MAPLEWOOD copy.jpg'
// import NAVAJO from './img/fullcolor/NAVAJO copy.jpg'
// import PECOS_BEIGE from './img/fullcolor/PECOS_BEIGE copy.jpg'
// import PHOENIX_TAN from './img/fullcolor/PHOENIX_TAN copy.jpg'
// import PUEBLO from './img/fullcolor/PUEBLO copy.jpg'
// import REDWOOD from './img/fullcolor/REDWOOD copy.jpg'
// import SALTILLO from './img/fullcolor/SALTILLO copy.jpg'
// import SAN_JOSE_BUFF from './img/fullcolor/SAN_JOSE_BUFF copy.jpg'
// import SAND_BUFF from './img/fullcolor/SAND_BUFF copy.jpg'
// import SANDSTONE from './img/fullcolor/SANDSTONE copy.jpg'
// import SEDONA from './img/fullcolor/SEDONA copy.jpg'
// import SILVER_GRAY from './img/fullcolor/SILVER_GRAY copy.jpg'
// import SOFT_GRAY from './img/fullcolor/SOFT_GRAY copy.jpg'
// import SOMBRA from './img/fullcolor/SOMBRA copy.jpg'
// import TAHOE_RED from './img/fullcolor/TAHOE_RED copy.jpg'
// import TERRA_COTTA from './img/fullcolor/TERRA_COTTA copy.jpg'
// import TIERRA from './img/fullcolor/TIERRA copy.jpg'
// import TILE_RED from './img/fullcolor/TILE_RED copy.jpg'
// import YUMA_GOLD from './img/fullcolor/YUMA_GOLD copy.jpg'

let colours = [
  AUSTIN_BUFF,
  AUTUMN_BROWN,
  BRICK_RED,
  CHARCOAL,
  CHEROKEE_RED,
  COCOA,
  CORDOVA,
  DARK_GRAY,
  DESERT_TAN,
  EURO_GRAY,
  FIESTA,
  MAPLEWOOD,
  NAVAJO,
  PECOS_BEIGE,
  PHOENIX_TAN,
  PUEBLO,
  REDWOOD,
  SALTILLO,
  SAN_JOSE_BUFF,
  SAND_BUFF,
  SANDSTONE,
  SEDONA,
  SILVER_GRAY,
  SOFT_GRAY,
  SOMBRA,
  TAHOE_RED,
  TERRA_COTTA,
  TIERRA,
  TILE_RED,
  YUMA_GOLD
]

let coloursNames = [
  'AUSTIN BUFF',
  'AUTUMN BROWN',
  'BRICK RED',
  'CHARCOAL',
  'CHEROKEE RED',
  'COCOA',
  'CORDOVA',
  'DARK_GRAY',
  'DESERT TAN',
  'EURO GRAY',
  'FIESTA',
  'MAPLEWOOD',
  'NAVAJO',
  'PECOS BEIGE',
  'PHOENIX TAN',
  'PUEBLO',
  'REDWOOD',
  'SALTILLO',
  'SAN JOSE BUFF',
  'SAND BUFF',
  'SANDSTONE',
  'SEDONA',
  'SILVER GRAY',
  'SOFT GRAY',
  'SOMBRA',
  'TAHOE RED',
  'TERRA COTTA',
  'TIERRA',
  'TILE RED',
  'YUMA GOLD'
]


function App() {

  let [showQRModal, setShowQRModal] = useState(false);
  let [showPDFModal, setShowPDFModal] = useState(false);
  let [colorCode, setColorCode] = useState('');

  let [maskSelected, setMaskSelected] = useState('');

  const pisoMaskRef = useRef();
  const muroMaskRef = useRef();
  const imgCasaRef = useRef();

  useEffect(() => {
    

    let hexs = document.querySelectorAll('.hexagon-in2');

    for (let i=0;i<hexs.length; i++) {

      // hexs[i].style.backgroundImage = 'url('+encodeURIComponent(colours[i].trim())+')';
      // hexs[i].style.backgroundImage = 'url('colour[i]+')';
      hexs[i].style.backgroundImage = `url(${colours[i]})`



      hexs[i].setAttribute('data-url', colours[i]);

      hexs[i].setAttribute('data-index', i);

      Velocity.animate(hexs[i], { opacity: 1, rotate: -60 }, { duration: 150, delay: i*50 });
      
    }

    

    Velocity.animate(imgCasaRef.current, { opacity: 1}, { duration: 150, delay: 200 });



    setTimeout(() => {
      pisoMaskRef.current.width = imgCasaRef.current.width;
      pisoMaskRef.current.height = imgCasaRef.current.height;

      muroMaskRef.current.width = imgCasaRef.current.width;
      muroMaskRef.current.height = imgCasaRef.current.height;      

      Velocity.animate(pisoMaskRef.current, { opacity: 1}, { duration: 150, delay: 50 });
      Velocity.animate(muroMaskRef.current, { opacity: 1}, { duration: 150, delay: 50 });

      selMask('piso');

    }, 1000);


  }, [])

  const hexClick = (ev) => {
    if (maskSelected == 'muro') {
      muroMaskRef.current.src = ev.target.attributes['data-url'].value;  
    } else if (maskSelected == 'piso') {
      pisoMaskRef.current.src = ev.target.attributes['data-url'].value;  
    }

    setColorCode(coloursNames[parseInt(ev.target.attributes['data-index'].value)])
    
  }

  const selMask = (item) => {
    switch (item) {
      case 'muro':
        document.querySelector('.button-muro').classList.add('inner-button-selected');
        document.querySelector('.button-piso').classList.remove('inner-button-selected');
        setMaskSelected('muro');
        break;
      case 'piso':
        document.querySelector('.button-muro').classList.remove('inner-button-selected');
        document.querySelector('.button-piso').classList.add('inner-button-selected');
        setMaskSelected('piso');
        break;
    }
  }


  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-1 g-0">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col-12 d-flex flex-column justify-center">

                <div className="row inner-board ps-5 pt-5 pb-5">
                  
                  <div className="d-flex flex-row pb-3">
                    <div className="d-flex flex-column justify-center">
                      <h3 className="t-54">Imagina con Fullcolor®</h3>
                    </div>
                    
                  </div>

                  <div className="col d-flex flex-row align-items-center ">

                    <div className="row">
                      <div className="col-5 d-flex flex-column justify-center align-items-center">

                        <div className="row pb-5">

                          <p className="pb-0 t-26">Escoge y cambia los colores que más te gusten</p>

                          <div className="hexagon-row"> 
                          
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                                               

                          </div>
                          <div className="hexagon-row even"> 
                          
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   

                          </div>

                          <div className="hexagon-row"> 
                          
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                                               

                          </div>

                          <div className="hexagon-row even"> 
                          
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            
                          </div>

                          <div className="hexagon-row"> 
                          
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                                               

                          </div>

                          <div className="hexagon-row even"> 
                          
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            <div className="hexagon hexagon1"><div className="hexagon-in1"><div className="hexagon-in2" onClick={hexClick}></div></div></div>                   
                            
                          </div>

                          <div className="spacer-100"></div>

                          <h3 className="pt-5 t-26">Código color: {colorCode}</h3>
                          <p className="pt-1">*Representaciones del color referenciales</p>

                        </div>


                      </div>
                      <div className="col-6">
                        <div className="row d-flex flex-column g-0 h-100">
                        <p className="t-26">Selecciona acá que quieres colorear </p>
                          <div className="d-flex flex-row pb-4">
                            
                            <button className="inner-button button-piso" onClick={() => selMask('piso')}><span>Piso <span className="chevron">></span></span></button>

                            <button className="inner-button button-muro ms-3" onClick={() => selMask('muro')}><span>Muro <span className="chevron">></span></span></button>
                          </div> 
                          <div className="d-flex flex-1">
                            <div className="img-comp mw-100 flex-1">
                              <img ref={muroMaskRef} className="mw-100 mask" src={null} style={{WebkitMaskBoxImage: 'url('+clip_muro+')', zIndex: 2}}/>
                              <img ref={pisoMaskRef} className="mw-100 mask" src={null} style={{WebkitMaskBoxImage: 'url('+clip_pavimento+')', zIndex: 2}}/>
                              <img ref={imgCasaRef} className="mw-100 casa" src={fullcolor_casa} />
                            </div>
                            
                          </div>
                          <div className="col d-flex flex-row space-between align-items-end">
                            <Link to="/productos/arquitectonicos/fullcolor" relative="path">
                            <button className="inner-button"><span>Ver producto <span className="chevron">></span></span></button>
                            </Link>
                          </div>                          
                        </div>
                        
                      </div>                      
                    </div>


                  </div>
                </div>
                
              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
